"use strict";
import {http} from '../../../core';
import Config from "../../../app.config";
const RequestService = http.create();


export default {
    //获取默认日期
    getDefaultData(){
        let data = new Date();
        let year = data.getFullYear();
        let months = data.getMonth();
        if(months == 0) {
            months = 12;
            year = year - 1;
        }
        if (months < 10) {
            months = "0" + months;
        }
        let startData = year + "-" + months + "-" + "01";
        let myDate = new Date(year, months, 0);
        let endData = year + "-" + months + "-" + myDate.getDate();
        let param = [startData,endData];
        return param;
    },
    /*
    * 转化百分比为整数
    *  m 第一个需要转化的小数
    *  n 第二个需要转化的小数
    */
    changeNum(data,m,n){
        data.forEach((item,index)=>{
            if(index > 0){
                item[m] = item[m] * 100;
                if(n){
                    item[n] = item[n] * 100;
                }
            }
        })
        return data;
    },
    /*
    * 小数的四舍五入
    *  m 表示保留几个小数
    */
    translateNum(data,m){
        return Number(data).toFixed(m);
    },

    //变更事件统计
    getlist(params){
        return  RequestService.get('change/manager/request/count',params)
    },
    //变更结果统计
    getRequestRatelist(params){
        return  RequestService.get('change/request/rate',params)
    },
    //紧急变更统计-表格
    getUrgentChangeTable(params){
        return  RequestService.get('urgent_change/table',params)
    },
    //紧急变更统计-图表
    getUrgentChangeChart(params){
        return  RequestService.get('urgent_change/graph',params)
    },


    //统计cab处理重大变更数量
    getCabRequestCount(params){
        return  RequestService.get('change/cab/request/count',params)
    },
    //重大更成功比例
    getCabRequestRate(params){
        return  RequestService.get('change/cab/request/rate',params)
    },
    //发布数量统计
    getPublishCount(params){
        return  RequestService.get('deploy/manager/request/count',params)
    },
    //发布成功失败比例
    getPublishRate(params){
        return  RequestService.get('deploy/request/rate',params)
    },
    //特殊统计 事件管理
    getEventCompleteRate(params){
        return  RequestService.get('event/complete',params)
    },
    //特殊统计 变更总数统计
    getChangeTotalCount(params){
        return  RequestService.get('change/total/count',params)
    },
    //特殊统计 发布总数统计
    getDeployTotalCount(params){
        return  RequestService.get('deploy/total/count',params)
    },
    //特殊统计 技术开发
    getContractStatisticsList(params){
        return  RequestService.get('service/contract_statistics',params)
    },
    //特殊统计 事件好评率
    getEventReviewList(params){
        return  RequestService.get('event/event_review',params)
    },
    //特殊统计 投诉和好评
    getEeventReviewComplaint(params){
        return  RequestService.get('event/event_review_complaint',params)
    },
    //特殊统计 事故管理
    getProblemFailCount(params){
        return  RequestService.get('problem/fail/count',params)
    },
    //特殊统计 事件sla
    getEventManageList(params){
        return  RequestService.get('event/event_manage',params)
    },
    //特殊统计 统计提交知识库数量
    getKnowledgeCountList(params){
        return  RequestService.get('knowledge/count',params)
    },
    //特殊统计 知识目录数统计
    getKnowledgeDirectoryCount(params){
        return  RequestService.get('knowledge/directory/count',params)
    },
    //特殊统计 问题数量统计
    getProblemTotalCount(params){
        return  RequestService.get('problem/total/count',params)
    },
}
